<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <BjSelectChannelStore
          :span="colSpan"
          :query-params="queryParams"
          :query-props="['channelTypeCode', 'storeIdList']"
          :query-labels="[
            $t('ChannelManagement.Header.method'),
            $t('ChannelManagement.Header.shop'),
          ]"
          multiple
        />

        <el-col :span="colSpan">
          <el-form-item :label="$t('ChannelManagement.Header.Store')" prop="status">
            <BjSelectLov v-model="queryParams.status" :placeholder="$t('ChannelManagement.Header.Store')" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>

      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:BusinessChannelOnlineCsgList_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            class="delete-btn"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:BusinessChannelOnlineCsgList_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('ChannelManagement.new.shop') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-tag
                v-else-if="col.prop === 'status'"
                :type="scope.row.status ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row.status)) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button v-permission:BusinessChannelOnlineCsgList_Edit type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="distribution">{{ $t('ChannelManagement.Main.distribution') }} </el-dropdown-item>
                  <el-dropdown-item v-if="props.row.status" v-permission:BusinessChannelOnlineCsgList_Status command="stop"> {{ $t('disableText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="!props.row.status" v-permission:BusinessChannelOnlineCsgList_Status command="start"> {{ $t('enableText') }} </el-dropdown-item>
                  <el-dropdown-item v-permission:BusinessChannelOnlineCsgList_Delete command="delete" :disabled="props.row.status"> {{ $t('delText') }} </el-dropdown-item>
                </el-dropdown-menu>
          </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />

  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { channelApi } from '@/api';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';
import DataForm from '../components/CsgDataForm.vue';

export default {
  name: 'BusinessChannelOnlineCsg',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      STATUS_ENABLED_TRUE,
      queryApi: channelApi.getOnlineShopPage,
      // 查询参数
      queryParams: {
        name: null,
        channelTypeCode: null,
        storeIdList: [],
        status: null,
      },
      title: this.$t('ChannelManagement.Main.she'),
      labelList: [
        { label: 'BusinessReportSaleShop.storeName', prop: 'name', isCheck: true, disabled: false },
        { label: 'ChannelManagement.Main.channel', prop: 'channelTypeMeaning', isCheck: true, disabled: false },
        { label: 'ChannelManagement.Main.sta', prop: 'status', isCheck: true, disabled: false, width: 130 },
        { label: 'ChannelManagement.Main.Creator', prop: 'createdName', isCheck: true, disabled: false },
        { label: 'ChannelManagement.Main.Creation', prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 }
      ],
      selectedRow: null,
    };
  },
  watch: {},
  created() {},
  methods: {
    command(text, row) {
      switch (text) {
        case 'distribution':
          this.onView(row);
          break;
        case 'stop':
          this.onStatus(false, row);
          break;
        case 'start':
          this.onStatus(true, row);
          break;
        case 'delete':
          this.onDelete(row);
          break;
      }
    },
    /** 新增网店 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 分配物流 */
    onView(row) {
      this.$toPage('BusinessChannelOnlineFlowDistributionCsg', { shopCode: row.code, shopId: row.id });
    },
    /** 编辑操作 */
    onEdit(row) {
      channelApi.getOnlineShopDetails({ id: row.id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          res.objectVersionNumber = row.objectVersionNumber;
          this.$refs.DataForm.show(this.$lodash.clone(res));
        }
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      this.$confirm(this.$t('ChannelManagement.Main.ps6'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            objectVersionNumber: row.objectVersionNumber,
            flag: flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(this.$t('ChannelManagement.Main.ps7'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi({
            id: row.id,
            objectVersionNumber: row.objectVersionNumber,
          });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.channelWarehouseStatus == true)) {
        this.$message.warning(this.$t('ChannelManagement.Main.ps8'));
        return;
      }

      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('ChannelManagement.Main.ps7'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('okText'),
        cancelButtonText: this.$t('cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },

    operationApi(API_DATA) {
      channelApi.operationOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps91'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    deleteApi(API_DATA) {
      channelApi.deleteOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps91'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      channelApi.batchDeleteOnlineShop(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('ChannelManagement.Main.ps91'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
